/* eslint-disable no-extra-boolean-cast */
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import DateTimePickerTranslated from 'components/shared/DateTimePickerTranslated/index';

export type FormFields = {
  creationDateFromUTC?: Date | null | string;
  creationDateToUTC?: Date | null | string;
  scheduleDateFromUTC?: Date | null | string;
  scheduleDateToUTC?: Date | null | string;
  closedDateFromUTC?: Date | null | string;
  closedDateToUTC?: Date | null | string;
  StartDateFromUTC?: Date | null | string;
  StartDateToUTC?: Date | null | string;
  AttendDateFromUTC?: Date | null | string;
  AttendDateToUTC?: Date | null | string;
  CancelledDateFromUTC?: Date | null | string;
  CancelledDateToUTC?: Date | null | string;
};

type Props = {
  form: UseFormReturn;
  title?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  title4?: string;
  title5?: string;
};

function DatePickerSearcher({
  form,
  title = 'common.commonProperties.creation',
  title1 = 'common.commonProperties.expiration',
  title2 = 'common.commonProperties.close',
  title3 = 'common.commonProperties.cancelation',
  title4 = 'common.commonProperties.start',
  title5 = 'common.commonProperties.attention'
}: Props) {
  const { watch } = form;

  const createDateFromUTC = watch('creationDateFromUTC');
  const scheduleDateFromUTC = watch('scheduleDateFromUTC');
  const closedDateFromUTC = watch('closedDateFromUTC');
  const CancelledDateFromUTC = watch('CancelledDateFromUTC');
  const StartDateFromUTC = watch('StartDateFromUTC');
  const AttendDateFromUTC = watch('AttendDateFromUTC');

  const createDateToUTC = watch('creationDateToUTC');
  const scheduleDateToUTC = watch('scheduleDateToUTC');
  const closedDateToUTC = watch('closedDateToUTC');
  const CancelledDateToUTC = watch('CancelledDateToUTC');
  const StartDateToUTC = watch('StartDateToUTC');
  const AttendDateToUTC = watch('AttendDateToUTC');
  const { t } = useTranslation('global');
  return (
    <>
      <Stack gap={2}>
        <Typography>{t(title)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: createDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="creationDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!createDateToUTC && !!createDateFromUTC) {
                return (
                  createDateToUTC > createDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: createDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="creationDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
      <Stack gap={2}>
        <Typography sx={{ paddingTop: 3 }}>{t(title1)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: scheduleDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="scheduleDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!scheduleDateToUTC && !!scheduleDateFromUTC) {
                return (
                  scheduleDateToUTC > scheduleDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: scheduleDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="scheduleDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
      <Stack gap={2}>
        <Typography sx={{ paddingTop: 3 }}>{t(title2)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: closedDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="closedDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!closedDateToUTC && !!closedDateFromUTC) {
                return (
                  closedDateToUTC > closedDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: closedDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="closedDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
      <Stack gap={2}>
        <Typography sx={{ paddingTop: 3 }}>{t(title3)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: CancelledDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="CancelledDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!CancelledDateToUTC && !!CancelledDateFromUTC) {
                return (
                  CancelledDateToUTC > CancelledDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: CancelledDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="CancelledDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
      <Stack gap={2}>
        <Typography sx={{ paddingTop: 3 }}>{t(title4)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: StartDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="StartDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!StartDateToUTC && !!StartDateFromUTC) {
                return (
                  StartDateToUTC > StartDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: StartDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="StartDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
      <Stack gap={2}>
        <Typography sx={{ paddingTop: 3 }}>{t(title5)}:</Typography>
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            max: AttendDateToUTC || '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.from')}
          name="AttendDateFromUTC"
          size="small"
          type="datetime-local"
          validation={{
            validate: () => {
              if (!!AttendDateToUTC && !!AttendDateFromUTC) {
                return (
                  AttendDateToUTC > AttendDateFromUTC ||
                  t('ticket.messages.toGreaterThanFrom')
                );
              }
            }
          }}
          variant="outlined"
        />
        <DateTimePickerTranslated
          control={form?.control}
          inputProps={{
            min: AttendDateFromUTC || '0000-01-01T00:00',
            max: '9999-12-31T23:59'
          }}
          label={t('common.commonProperties.to')}
          name="AttendDateToUTC"
          size="small"
          type="datetime-local"
          variant="outlined"
        />
      </Stack>
    </>
  );
}

export default DatePickerSearcher;
